import { Result } from "antd";

const IeCheck = ({ children }) => {
	const isIe = window.document.documentMode ? true : false;
	return isIe ? (
		<Result
			status="warning"
			title="Sorry, you can't open this application in Internet Explorer"
		>
			<div>
				<p>
					Please use Edge browser to access this application instead.
				</p>
				<p>Instructions on how to find Edge on your computer</p>
				<ul>
					<li>
						Click the Start menu button on your task bar, or press
						the Windows key on your keyboard
					</li>
					<li>
						In the <i>Search programs and files</i> box, type in
						Edge
					</li>
					<li>Click Microsoft Edge shortcut</li>
					<li>
						Navigate to this application via Staffnet, or paste in
						the URL to this application
					</li>
				</ul>
			</div>
		</Result>
	) : (
		<>{children}</>
	);
};

export default IeCheck;
